import Vue from 'vue'
import Vuex from 'vuex'
import brightness from "./brightness";

const LOGIN = "LOGIN";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGOUT = "LOGOUT";
const UPDATE_PERMISSIONS = "UPDATE_PERMISSIONS";

Vue.use(Vuex);

const getAuthData = (key) => localStorage.getItem(key) || sessionStorage.getItem(key);

export default new Vuex.Store({
  modules: {
    brightness
  },
  state: {
    isLoggedIn: !!getAuthData("token"),
    role: getAuthData("role"),
    permissions: getAuthData("permissions")
  },
  mutations: {
    [LOGIN](state) {
      state.pending = true;
    },
    [LOGIN_SUCCESS](state) {
      state.isLoggedIn = true;
      state.role = getAuthData("role");
      state.permissions = getAuthData("permissions");
      state.pending = false;
    },
    [LOGOUT](state) {
      state.isLoggedIn = false;
      state.role = null;
      state.permissions = null;
    },
    [UPDATE_PERMISSIONS](state) {
      state.role = localStorage.getItem("role");
      state.permissions = localStorage.getItem("permissions");
    }
  },
  actions: {
    login({ commit }, creds) {
      const storage = creds.rememberToken ? localStorage : sessionStorage;

      commit(LOGIN); // show spinner
      return new Promise(resolve => {
        setTimeout(() => {
          storage.setItem("token", creds.token);
          if (creds.refreshToken) {
            storage.setItem("refresh_token", creds.refreshToken);
          }
          storage.setItem("role", creds.role);
          storage.setItem("permissions", creds.permissions);
          commit(LOGIN_SUCCESS);
          resolve();
        }, 10);
      });
    },
    logout({ commit }) {
      const refreshToken = localStorage.getItem("refresh_token") || sessionStorage.getItem("refresh_token");
      const revokeRequest = refreshToken
        ? Vue.http.post("logout", {refresh_token: refreshToken}).catch(() => {})
        : Promise.resolve();

      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("role");
      localStorage.removeItem("permissions");
      sessionStorage.clear();

      commit(LOGOUT);
      return revokeRequest;
    },
    updatePermissions({commit}, payload) {
      localStorage.setItem("role", payload.role);
      localStorage.setItem("permissions", payload.permissions);
      commit(UPDATE_PERMISSIONS);
    }
  },
  getters: {
    isLoggedIn: state => {
      return state.isLoggedIn;
    },
    permissions: state => {
      if (state.permissions == null) { return []; }
      if (state.permissions.length === 0) { return []; }
      return state.permissions.split(',');
    },
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js